import { MonthYear } from '@common/types';
import VueCqrs from '@cqrs/vue-component-cqrs';
import * as c from '@Quest/Portfolios/Domain/commands-core';
import { Component } from 'vue-facing-decorator';

@Component
export default class PortfoliosCommands extends VueCqrs {

	invokeCreatePortfolioCommandV1(strategyWorkspaceId: number, portfolioWorkspaceId: number, strategyId: string, portfolioId: string, name: string, description: string)
	{
		const cmd = new c.CreatePortfolioCommandV1(strategyWorkspaceId, portfolioWorkspaceId, strategyId, portfolioId, name, description);
		this.$command(cmd, portfolioId);
	}

	invokeLinkPortfolioCommandV1(workspaceId: number, strategyId: string, portfolioId: string, portfolioWorkspaceId: number, portfolioTchProjectId: number)
	{
		const cmd = new c.LinkPortfolioCommandV1(workspaceId, strategyId, portfolioId, portfolioWorkspaceId, portfolioTchProjectId);
		this.$command(cmd, portfolioId);
	}

	invokeDeletePortfolioCommandV1(workspaceId: number, portfolioId: string)
	{
		const cmd = new c.DeletePortfolioCommandV1(workspaceId, portfolioId);
		this.$command(cmd, portfolioId);
	}

	invokeUpdatePortfolioSettingsCommandV1(workspaceId: number, portfolioId: string, name: string, description: string | null, benefitsConfidenceDate: MonthYear | null,
		excludedResourceIds: string[], excludedRevenueIds: string[], excludedExpenseIds: string[], excludedCapexIds: string[])
	{
		const cmd = new c.UpdatePortfolioSettingsCommandV1(workspaceId, portfolioId, name, description, benefitsConfidenceDate,
			excludedResourceIds, excludedRevenueIds, excludedExpenseIds, excludedCapexIds);

		this.$command(cmd, portfolioId);
	}

	invokeImportProjectPlansFromSpreadsheetCommandV1(workspaceId: number, portfolioId: string, blobId: string, importedPlanName: string)
	{
		const cmd = new c.ImportProjectPlansFromSpreadsheetCommandV1(workspaceId, portfolioId, blobId, importedPlanName);
		this.$command(cmd, blobId);
	}

	invokeExportAllActiveProjectPlansCommandV1(workspaceId: number, portfolioId: string)
	{
		const cmd = new c.ExportAllActiveProjectPlansCommandV1(workspaceId, portfolioId);
		this.$command(cmd, portfolioId);
	}



	invokeSaveViewAllProjectsPageCommandV1(workspaceId: number, portfolioId: string, grid: string)
	{
		const cmd = new c.SaveViewAllProjectsPageCommandV1(workspaceId, portfolioId, grid);
		this.$command(cmd, portfolioId);
	}

	invokeSaveViewProposedProjectsPageCommandV1(workspaceId: number, portfolioId: string, grid: string)
	{
		const cmd = new c.SaveViewProposedProjectsPageCommandV1(workspaceId, portfolioId, grid);
		this.$command(cmd, portfolioId);
	}

	invokeSaveViewScheduledProjectsPageCommandV1(workspaceId: number, portfolioId: string, grid: string)
	{
		const cmd = new c.SaveViewScheduledProjectsPageCommandV1(workspaceId, portfolioId, grid);
		this.$command(cmd, portfolioId);
	}

	invokeSaveViewStartedProjectsPageCommandV1(workspaceId: number, portfolioId: string, grid: string)
	{
		const cmd = new c.SaveViewStartedProjectsPageCommandV1(workspaceId, portfolioId, grid);
		this.$command(cmd, portfolioId);
	}

	invokeSaveViewFinishedProjectsPageCommandV1(workspaceId: number, portfolioId: string, grid: string)
	{
		const cmd = new c.SaveViewFinishedProjectsPageCommandV1(workspaceId, portfolioId, grid);
		this.$command(cmd, portfolioId);
	}


	invokeSaveViewOwnerProjectsPageCommandV1(workspaceId: number, portfolioId: string, grid: string)
	{
		const cmd = new c.SaveViewOwnerProjectsPageCommandV1(workspaceId, portfolioId, grid);
		this.$command(cmd, portfolioId);
	}
}
